import { useState } from 'react';
import { Box } from '@mui/joy';
import { AnimatePresence, motion } from 'framer-motion';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import { PageHeader, FinanceTabs } from './financeShared';
import FinanceDashboardTab from './FinanceDashboardTab';
import FinanceHealthTab from './FinanceHealthTab';
import FinanceRewardsTab from './FinanceRewardsTab';
import FinanceCashflowTab from './FinanceCashflowTab';
import FinanceReceivablesTab from './FinanceReceivablesTab';
import FinancePayablesTab from './FinancePayablesTab';
import FinancePaymentCalendarTab from './FinancePaymentCalendarTab';
import FinanceSurveysTab from './FinanceSurveysTab';

const TABS = [
  { key: 'dashboard',   label: 'PNL',                 Comp: FinanceDashboardTab },
  { key: 'health',      label: 'Показатели здоровья', Comp: FinanceHealthTab },
  { key: 'rewards',     label: 'Вознаграждения',       Comp: FinanceRewardsTab },
  { key: 'cashflow',    label: 'ДДС',                  Comp: FinanceCashflowTab },
  { key: 'receivables', label: 'Дебиторка',            Comp: FinanceReceivablesTab },
  { key: 'payables',    label: 'Кредиторка',           Comp: FinancePayablesTab },
  { key: 'calendar',    label: 'Платёжный календарь',   Comp: FinancePaymentCalendarTab },
  { key: 'surveys',     label: 'Замеры',               Comp: FinanceSurveysTab },
];

export default function FinancePage() {
  const [tab, setTab] = useState('dashboard');
  const Active = TABS.find((t) => t.key === tab)?.Comp || (() => null);

  return (
    <Box sx={{ px: { xs: 0, md: 3 }, py: { xs: 2, md: 3 }, maxWidth: 1400, mx: 'auto', minWidth: 0 }}>
      <PageHeader
        icon={<AccountBalanceWalletRoundedIcon sx={{ color: '#fff', fontSize: 20 }} />}
        title="Финансы"
        subtitle="Доходы, расходы, дебиторка, кредиторка и здоровье бизнеса"
      />

      <Box sx={{ px: { xs: 2, md: 0 }, mb: 2 }}>
        <FinanceTabs tabs={TABS} value={tab} onChange={setTab} />
      </Box>

      <Box sx={{ px: { xs: 2, md: 0 } }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={tab}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.22 }}
          >
            <Active />
          </motion.div>
        </AnimatePresence>
      </Box>
    </Box>
  );
}